import { render, staticRenderFns } from "./ManterFAQView.vue?vue&type=template&id=6ddec58e&scoped=true&"
import script from "./ManterFAQView.vue?vue&type=script&lang=js&"
export * from "./ManterFAQView.vue?vue&type=script&lang=js&"
import style0 from "./ManterFAQView.vue?vue&type=style&index=0&id=6ddec58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddec58e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VRow,VTextField})
